import { TweenMax, Expo } from 'gsap/TweenMax';
import animations from '@/scripts/animations';
import { getArrayDeltaPercent } from '@/scripts/utils';
import store from '@/store';


export default class Navigator {
  constructor(el) {
    this.nav = el;
    this.dots = Array.from(this.nav.querySelectorAll('.navigator__dot'));
    this.progressBar = this.nav.querySelector('.navigator__progress');
    this.caption = this.nav.querySelector('.navigator__caption');
    this.burger = document.querySelector('.burger');
    this.isOpen = false;

    this.state = 'initial';
    this.prevResizeTimeline = null;

    this.init();
  }

  init() {
    TweenMax.set(this.nav, { autoAlpha: 0 });
  }

  enter(type = 'default') {
    this.state = 'initial';
    this.isOpen = false;

    return animations.get('navEnter')(
      this.nav,
      this.dots,
      this.caption,
      this.progressBar,
      type,
    );
  }

  toScroll() {
    this.state = 'scroll';

    return animations.get('navToScroll')(
      this.nav,
      this.dots,
      this.caption,
    );
  }

  toPage() {
    this.state = 'scroll';

    return animations.get('navToPage')(
      this.nav,
      this.dots,
      this.caption,
    );
  }

  toDrag() {
    this.state = 'drag';

    return animations.get('navToDrag')(
      this.nav,
      this.dots,
      this.caption,
    );
  }

  animateProgress(index, time = 2) {
    const indexNorm = index < 0 ? this.dots.length - 1 : index;
    const scale = indexNorm * getArrayDeltaPercent(this.dots) / 100;

    return TweenMax.to(this.progressBar, time, {
      scaleX: scale,
      ease: Expo.easeInOut,
    });
  }

  resize() {
    if (this.prevResizeTimeline !== null) this.prevResizeTimeline.kill();
    if (!store.state.scrollIsLocked) return;


    if (this.state === 'scroll') {
      this.prevResizeTimeline = this.toScroll();
    } else if (this.state === 'drag') {
      this.prevResizeTimeline = this.toDrag();
    } else {
      this.prevResizeTimeline = this.enter();
    }
  }

  get progress() {
    return this.progressBar.getBoundingClientRect().width / this.progressBar.offsetWidth;
  }

  set progress(numb) {
    const scale = numb / 100;
    this.progressBar.style.transform = `scaleX(${scale})`;
  }
}
